import { render, staticRenderFns } from "./EmailModal.vue?vue&type=template&id=5174aea0&scoped=true"
import script from "./EmailModal.vue?vue&type=script&lang=js"
export * from "./EmailModal.vue?vue&type=script&lang=js"
import style0 from "./EmailModal.vue?vue&type=style&index=0&id=5174aea0&prod&scoped=true&lang=less"
import style1 from "./EmailModal.vue?vue&type=style&index=1&id=5174aea0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5174aea0",
  null
  
)

export default component.exports